/* eslint-disable padded-blocks */
import React from 'react';
import './contentview.scss';
import { Link } from 'react-router-dom';
import Parser from 'html-react-parser';
import { withRouter } from 'react-router-dom';
import { umoksType } from '../../../types/types.js';
import { Scrollbars } from 'react-custom-scrollbars';
import DevPages from '../../devpages/devpages.jsx';


class ContentView extends React.Component {
  constructor(props) {
    super(props);
  };
  getContent = () => {
    const { pathname } = this.props.location;
    const { sectionContent } = this.props;

    const getAnimalsContent = animals => {
      let content = [];
      for (let i = 0; i < animals.length; i++) {
        const item = animals[i];
        content.push(<li key={item.id}><Link to={item.link}>{item.label}</Link></li>);
      }
      return content;
    }


    if (sectionContent.length > 0) {
      for (let i = 0; i < sectionContent.length; i++) {
        for (let c = 0; c < sectionContent[i].content.length; c++) {
          if (sectionContent[i].content[c].route ===  pathname) {
            console.log(sectionContent[i].content[c].html.length);
            if (sectionContent[i].content[c].html.length > 0) {
              if (sectionContent[i].content[c].title === 'Газ для побутових споживачів'|| sectionContent[i].content[c].title === 'Приєднатися до нас:' || sectionContent[i].content[c].title === 'Газ для юридичних осіб та фізичних осіб-підприємців') {
                const options = {
                  replace: ({ attribs }) => {
                    if (!attribs) return;
                    if (attribs.id === 'loclink') {
                        return (
                          <span>{getAnimalsContent(sectionContent[i].content[c].items)}</span>
                        );

                    }
                  }
                };
                return (
                  <div className='wrap-content'>
                    <h2>{sectionContent[i].content[c].title}</h2>
                    {Parser(sectionContent[i].content[c].html.join(''),options)}
                  </div>
                );
              } return (
                <div className='wrap-content'>
                  <h2>{sectionContent[i].content[c].title}</h2>
                  {Parser(sectionContent[i].content[c].html.join(''))}
                </div>
              );
            }

            return (
              <div className='wrap-content'>
                <h2>{sectionContent[i].content[c].title}</h2>
                <DevPages />
              </div>
            );
            ;
          }
        };
      }
    };
  };


  render() {
    return (
      <article className='view-wrap'>
        <Scrollbars
          className='performer-scroll'
          onUpdate={this.handleUpdate}
          autoHide={true}
          autoHideTimeout={1000}
          autoHideDuration={200}
          thumbMinSize={30}
          universal={true}
          style={{ height: '750px' }}
          renderTrackHorizontal={props => <div {...props} className='track-horizontal'/>}
          renderTrackVertical={props => <div {...props} className='track-vertical'/>}
          renderThumbHorizontal={props => <div {...props} className='thumb-horizontal'/>}
          renderThumbVertical={props => <div {...props} className='thumb-vertical'/>}
          renderView={props => <div {...props} className='view'/>}>
          {this.getContent()}
        </Scrollbars>
      </article>
    );
  };
};

ContentView.propTypes = {
  buisnessList:umoksType.isRequired
};

export default withRouter(ContentView);



// WEBPACK FOOTER //
// ./src/client/components/categorywrap/contentview/contentview.jsx